import { Box, Button, ButtonGroup, Paper, Tab, Tabs, Typography, TextField, Popover } from '@material-ui/core'
import { DataGrid } from '@material-ui/data-grid'
import { TabPanel } from '@material-ui/lab'
import moment from 'moment'
import React from 'react'
import { useState } from 'react'
import { useQuery } from 'react-query'
import ShareConfigDialog from '../../../components/ShareConfigDialog'
import { ShareType } from '../../../constants'
import { formatPrice } from '../../../utils'
import { ShareAPI } from '../../../utils/api'
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRange, OnDateRangeChangeProps, Range } from 'react-date-range'
import locale from 'date-fns/locale/zh-CN'
import { useEffect } from 'react'
import { useFeedback } from '../../../components/Feedback'
const ShareManage = () => {
  const [dateRange, setDateRange] = useState<Range>({
    startDate: undefined,
    endDate: undefined,
    key: 'selection'
  })
  const {showLoading,hideLoading,showToast} = useFeedback()
  const { data,refetch } = useQuery(['admin/share/config'], () => ShareAPI.listConfig())
  const [dateType, setDateType] = useState('all');
  const { data: rewards } = useQuery(['admin/share/config/reward',dateRange.startDate,dateRange.endDate], () => ShareAPI.listReward(dateRange.startDate,dateRange.endDate))

  useEffect(() => {
    switch (dateType) {
      case '30d':
        setDateRange({
          ...dateRange,
          startDate: moment().subtract(30,'d').toDate(),
          endDate: moment().toDate()
        })
        break;
      case '7d':
        setDateRange({
          ...dateRange,
          startDate: moment().subtract(7,'d').toDate(),
          endDate: moment().toDate()
        })
        break;
      case 'custom':
       
        break;
      default: 
      setDateRange({
        ...dateRange,
        startDate: undefined,
        endDate: undefined
      })
    }
  }, [dateType])


  const [editConfig, setEditConfig] = useState<ShareConfig>()
  const [tabIndex, setTabIndex] = useState(0)
  const handleEditConfig = (config: ShareConfig) => () => {
    setEditConfig(config)
  }

  const handleChangeDateType =(type: string) => () => {
    setDateType(type)
  }

  const handleDateRangeChange = (item: OnDateRangeChangeProps) => {
    const {selection} = item
    if(selection.startDate != selection.endDate) {
      handleDateRangeClose()
      setDateType('custom')
    }
    setDateRange({ ...selection })
  }

  const handleExportData = () => {
    showLoading('导出中')
    ShareAPI.exportReward(dateRange.startDate,dateRange.endDate).then(res=> {
      console.info(res)
      window.open('/api/admin/file/' + res)
      hideLoading()
    }).catch(e=>{
      hideLoading()
      showToast('导出失败')
    })
  }

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const handleShowDateRange = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setDateRange({
      ...dateRange,
      startDate: dateRange.startDate || new Date(),
      endDate: dateRange.endDate || new Date()
    })
  };
  const handleDateRangeClose = () => {
    setAnchorEl(null);
  }
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  return <Box>
    <Box display="flex" justifyContent="space-between">
      <Box>
        <Tabs value={tabIndex} onChange={(_, v) => setTabIndex(v)}>
          <Tab label="提成奖励" />
          <Tab label="分享设置" />
        </Tabs>
      </Box>
      <Box display="flex" alignItems="center">
        <ButtonGroup style={{ marginRight: '10px' }}>
          <Button onClick={handleChangeDateType('all')} size="small" color={dateType === 'all' ? 'primary': 'default'}>全部</Button>
          <Button onClick={handleChangeDateType('7d')}  size="small" color={dateType === '7d' ? 'primary': 'default'}>7天</Button>
          <Button onClick={handleChangeDateType('30d')}  size="small" color={dateType === '30d' ? 'primary': 'default'}>30天</Button>
        </ButtonGroup>
        <Button onClick={handleShowDateRange} color={dateType === 'custom' ? 'primary': 'default'} variant="outlined" size="small" >时间</Button>
        <Button onClick={handleExportData} style={{ marginLeft: '10px' }} variant="contained" size="small" >导出</Button>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleDateRangeClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <DateRange
            locale={locale}
            onChange={handleDateRangeChange}
            ranges={[
              dateRange
            ]} />
        </Popover>

      </Box>
    </Box>

    <Box mt={2}>
      <Paper>
        {tabIndex === 0 ?
          <Box>
            <DataGrid autoHeight hideFooter disableColumnResize={undefined} columns={[
              {
                field: 'content', headerName: "分享内容", flex: 1,
              },
              {
                field: 'user_mobile',
                headerName: '分享受益人',
                width: 200
              },
              { field: 'buyer_mobile', headerName: '购买者', width: 200 },
              {
                field: 'order_amount', headerName: '付费金额', width: 140, valueFormatter: params => {
                  return '¥' + formatPrice(params.value as number)
                }
              },

              {
                field: 'reward_ratio', headerName: '提成比例', width: 140, valueFormatter: params => {
                  return params.value ? params.value + '%' : '-'
                }
              },
              {
                field: 'reward_amount', headerName: '提成金额', width: 140, valueFormatter: params => {
                  return '¥' + formatPrice(params.value as number)
                }
              },
              {
                field: 'purchased_time', headerName: '付费时间', width: 140, valueFormatter: params => {
                  return moment(params.value as number).format('YYYY-MM-DD HH:mm')
                }
              },

            ]} rows={rewards || []} />
          </Box>
          : <Box>
            <DataGrid autoHeight hideFooter  columns={[
              {
                field: 'type', headerName: "分享类型", width: 200, valueFormatter: params => {
                  const type = params.value as string
                  return ShareType[type]
                }
              },
              { field: 'content', headerName: '分享内容', flex: 1,resizable: true },
              {
                field: 'ratio', headerName: '提成比例', width: 140, align: 'center', headerAlign: 'center', valueFormatter: params => {
                  return params.value ? params.value + '%' : '-'
                }
              },
              { field: 'share_title', headerName: '分享标题', flex: 1 },
              { field: 'share_image', headerName: '分享图片', width: 140 },
              {
                field: 'id', headerName: '操作', width: 140, renderCell: params => {
                  return <Box>
                    <Button size="small" onClick={handleEditConfig(params.row as ShareConfig)}>编辑</Button>
                  </Box>
                }
              }
            ]} rows={data?.list || []} />
          </Box>}
      </Paper>
      <ShareConfigDialog type={editConfig?.type || ''} typeKey={editConfig?.key} open={Boolean(editConfig)} onClose={(save?: boolean) => {
        if(save){
          refetch()
        }
        setEditConfig(undefined)
      }} />
    </Box>
  </Box>
}

export default ShareManage